<!-- <div class="order-success-sec" *ngIf="createOrder"> -->
<div *ngIf="!isEmployee && createOrder" class="order-success-sec">
    <img src="{{successIcon}}" alt="">
    <!-- <span class="close-button" (click)="closePopup()">✖</span> -->
    <h3>Order Created!</h3>
    <p class="order-label">Order ID <span class="order-id">#{{order.orderNumber}}</span></p>
    <!-- <p class="date-text"><span>{{order.orderDate | date: 'MMM dd yyyy hh:mm a'}}</span></p> -->
    <p class="date-text">{{order.orderDate}}</p>

    <button class="goto-order" (click)="goToOrder()">Track My Order</button>
</div>
<!-- <div *ngIf="magicOrder" class="success-popup-overlay"> -->
<div *ngIf="!isEmployee && magicOrder" class="success-popup-overlay">
  <div class="success-popup">
    <div class="success-icon"><img src="{{successIcon}}" alt=""></div>
    <h2>Order Created Successfully! 🎉</h2>
    <p class="order-number">Order No. {{order.orderNumber}}</p>
    <p class="order-date">{{order.orderDate}}</p>

    <div class="info-box" *ngIf="missingArray.length>0">
      <i>watch_later</i>
      <div>
      <p style="margin-bottom: 0;"><strong>We're still sourcing the best prices for:</strong></p>
        <div class="scroll">
      <ul *ngFor="let item of missingArray">
        <li>{{item}}</li>
      </ul>
    </div>
      <div>
        A request has been created for the remaining items.<br />
        🔍 <strong>Request ID: {{requestId}}</strong><br />
        <p class="track-page">
        You can track it in the "My Requests" page.
        </p>
      </div>
      </div>
    </div>

    <button class="track-btn" (click)="goToOrder()">🎁 TRACK YOUR ORDER</button>
    <a class="my-requests-link" (click)="requestSuccessPopup()"  *ngIf="missingArray.length>0">Go to My Requests</a>
  </div>
</div>

<!-- ================================================AUTOVERSE EMPLOYEE UI================================ -->

<div *ngIf="isEmployee && createOrder" class="employee-popup" (click)="onOverlayClick()">

  <div class="popup-card"  #popupCard tabindex="0">

    <div class="close-btn" (click)="closePopup()"><mat-icon>close</mat-icon></div>

    <!-- SUCCESS ICON -->
    <div class="success-wrapper">
      <div class="success-circle">
        <img src="{{successIcon}}" alt="">
      </div>
    </div>

    <h2 class="title">Order Created!</h2>

    <!-- INFO SECTION -->
    <div class="info-box">
      <div class="info-row">
        <div class="icon"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.49999 10H12.5M7.49999 13.3333H12.5M14.1667 17.5H5.83332C5.3913 17.5 4.96737 17.3244 4.65481 17.0118C4.34225 16.6993 4.16666 16.2754 4.16666 15.8333V4.16667C4.16666 3.72464 4.34225 3.30072 4.65481 2.98816C4.96737 2.67559 5.3913 2.5 5.83332 2.5H10.4883C10.7093 2.50005 10.9212 2.58788 11.0775 2.74417L15.5892 7.25583C15.7454 7.41208 15.8333 7.624 15.8333 7.845V15.8333C15.8333 16.2754 15.6577 16.6993 15.3452 17.0118C15.0326 17.3244 14.6087 17.5 14.1667 17.5Z" stroke="#3B82F6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div>
          <p class="label">Order Number</p>
          <p class="value">{{order.orderNumber}}</p>
        </div>
      </div>

      <div class="info-row">
        <div class="icon"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 6.66667V10L12.5 12.5M17.5 10C17.5 10.9849 17.306 11.9602 16.9291 12.8701C16.5522 13.7801 15.9997 14.6069 15.3033 15.3033C14.6069 15.9997 13.7801 16.5522 12.8701 16.9291C11.9602 17.306 10.9849 17.5 10 17.5C9.01509 17.5 8.03982 17.306 7.12987 16.9291C6.21993 16.5522 5.39314 15.9997 4.6967 15.3033C4.00026 14.6069 3.44781 13.7801 3.0709 12.8701C2.69399 11.9602 2.5 10.9849 2.5 10C2.5 8.01088 3.29018 6.10322 4.6967 4.6967C6.10322 3.29018 8.01088 2.5 10 2.5C11.9891 2.5 13.8968 3.29018 15.3033 4.6967C16.7098 6.10322 17.5 8.01088 17.5 10Z" stroke="#3B82F6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div>
          <p class="label">Date & Time</p>
          <p class="value">{{order.orderDate}}</p>
        </div>
      </div>
    </div>

    <!-- ROUTE -->
    <div class="order-route-txt-and-icn">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.5 16.6666L2.96083 14.3966C2.82243 14.3275 2.70602 14.2212 2.62463 14.0896C2.54324 13.958 2.50008 13.8064 2.5 13.6516V4.68165C2.50008 4.53965 2.53643 4.40004 2.60562 4.27604C2.67481 4.15204 2.77453 4.04778 2.89533 3.97315C3.01613 3.89852 3.15399 3.85599 3.29584 3.8496C3.43769 3.84321 3.57882 3.87318 3.70583 3.93665L7.5 5.83331M7.5 16.6666L12.5 14.1666M7.5 16.6666V5.83331M7.5 5.83331L12.5 3.33331M12.5 14.1666L16.2942 16.0633C16.4212 16.1268 16.5623 16.1567 16.7042 16.1504C16.846 16.144 16.9839 16.1014 17.1047 16.0268C17.2255 15.9522 17.3252 15.8479 17.3944 15.7239C17.4636 15.5999 17.4999 15.4603 17.5 15.3183V6.34831C17.4999 6.19359 17.4568 6.04195 17.3754 5.91037C17.294 5.77879 17.1776 5.67247 17.0392 5.60331L12.5 3.33331M12.5 14.1666V3.33331" stroke="#3B82F6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>

      <div class="route-title">Order Route</div>
    </div>
    <div class="route-box">
      <div class="route-row">
        <div class="route-icon"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19 21V5C19 4.46957 18.7893 3.96086 18.4142 3.58579C18.0391 3.21071 17.5304 3 17 3H7C6.46957 3 5.96086 3.21071 5.58579 3.58579C5.21071 3.96086 5 4.46957 5 5V21M19 21H21M19 21H14M5 21H3M5 21H10M14 21V16C14 15.7348 13.8946 15.4804 13.7071 15.2929C13.5196 15.1054 13.2652 15 13 15H11C10.7348 15 10.4804 15.1054 10.2929 15.2929C10.1054 15.4804 10 15.7348 10 16V21M14 21H10M9 7H10M9 11H10M14 7H15M14 11H15" stroke="#3B82F6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div>
          <p class="route-label">FROM</p>
          <p class="route-text">
            {{order.pickupLocation}}
          </p>
        </div>
      </div>

      <div class="route-divider">
        <span></span>
        <div class="truck"><svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M24 24.6666C23.4696 24.6666 22.9609 24.4559 22.5858 24.0809C22.2107 23.7058 22 23.1971 22 22.6666C22 22.1362 22.2107 21.6275 22.5858 21.2524C22.9609 20.8774 23.4696 20.6666 24 20.6666C24.5304 20.6666 25.0392 20.8774 25.4142 21.2524C25.7893 21.6275 26 22.1362 26 22.6666C26 23.1971 25.7893 23.7058 25.4142 24.0809C25.0392 24.4559 24.5304 24.6666 24 24.6666ZM26 12.6666L28.6133 16H22.6667V12.6666M8.00001 24.6666C7.46958 24.6666 6.96087 24.4559 6.5858 24.0809C6.21072 23.7058 6.00001 23.1971 6.00001 22.6666C6.00001 22.1362 6.21072 21.6275 6.5858 21.2524C6.96087 20.8774 7.46958 20.6666 8.00001 20.6666C8.53044 20.6666 9.03915 20.8774 9.41422 21.2524C9.7893 21.6275 10 22.1362 10 22.6666C10 23.1971 9.7893 23.7058 9.41422 24.0809C9.03915 24.4559 8.53044 24.6666 8.00001 24.6666ZM26.6667 10.6666H22.6667V5.33331H4.00001C2.52001 5.33331 1.33334 6.51998 1.33334 7.99998V22.6666H4.00001C4.00001 23.7275 4.42144 24.7449 5.17158 25.4951C5.92173 26.2452 6.93914 26.6666 8.00001 26.6666C9.06088 26.6666 10.0783 26.2452 10.8284 25.4951C11.5786 24.7449 12 23.7275 12 22.6666H20C20 23.7275 20.4214 24.7449 21.1716 25.4951C21.9217 26.2452 22.9391 26.6666 24 26.6666C25.0609 26.6666 26.0783 26.2452 26.8284 25.4951C27.5786 24.7449 28 23.7275 28 22.6666H30.6667V16L26.6667 10.6666Z" fill="#3B82F6"/>
          </svg>
        </div>
        <span></span>
      </div>

      <div class="route-row">
        <div class="route-icon"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 14V17M12 14V17M16 14V17M3 21H21M3 10H21M3 7L12 3L21 7M4 10H20V21H4V10Z" stroke="#3B82F6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div>
          <p class="route-label">TO</p>
          <p class="route-text">
            {{order.dropoffLocation}}
          </p>
        </div>
      </div>
    </div>

    <p class="footer-text">Let us deliver an awesome experience!</p>

    <button class="track-btn" (click)="goToOrder()">
      <div  class="track-btn-txt" >TRACK YOUR ORDER </div>
      <mat-icon>arrow_forward</mat-icon>
    </button>

  </div>
</div>